export default "__VITE_ASSET__aI4jwdVe__"